import React, { useState } from "react";
import { FilterListIcon } from "../../utils/icons";
import Filter from "../Filter";
import { Menu } from "@mui/material";
import "./YearFilter.scss";

const YearFilter = ({ onFilterClick = () => {}, isYear = false, onReset = () => {} }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleFilterClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className='headerFilter'>
      <div className='headerFlexCenter'>
        <div onClick={handleFilterClick} style={{ padding: 0, display: "flex", flexDirection: "row" }}>
          <FilterListIcon
            style={{
              height: "18px",
              width: "18px",
              color: "#333333",
              marginRight: "5px",
              marginTop: "2px",
            }}
          />
          <div className='headerFilterText'>Year</div>
        </div>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          sx={{}}
          PaperProps={{
            sx: {
              marginTop: "10px",
              marginLeft: "-6px",
              padding: "0 !important",
              border: "1px solid #E6E6E6",
              borderTopLeftRadius: "8px",
              borderTopRightRadius: "8px",
            },
          }}>
          {/* <div>Hello</div> */}
          <Filter onClick={onFilterClick} onClose={handleClose} onReset={onReset} isYear={true} />
          {/* <MenuItem onClick={handleClose}>Profile</MenuItem>
                <MenuItem onClick={handleClose}>My Account</MenuItem>
                <MenuItem onClick={handleClose}>Logout</MenuItem> */}
        </Menu>
      </div>
    </div>
  );
};

export default YearFilter;
